import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  styled,
} from "@mui/material";
import React, { memo } from "react";
import CloseIcon from "@mui/icons-material/Close";
import T from "utils/constants/T";

interface AlertConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  children?: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
}

const AlertBootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-container": {
    height: "100%",
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    width: "100%",
  },
}));

const AlertConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title,
  children,
  confirmText = T.CONFIRM.toUpperCase(),
  cancelText = T.CANCEL.toUpperCase(),
}: AlertConfirmationModalProps) => {
  return (
    <AlertBootstrapDialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          backgroundColor: "#fdecea",
          borderBottom: "1px solid #f44336",
          padding:"16px 16px",
          color: "#b71c1c",
          position: "relative",
        }}
      >
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#b71c1c",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          backgroundColor: "#fdecea",
          borderTop: "none",
          color: "#b71c1c",
          width: "100%",
        }}
      >
        {children}

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          <Button
            variant="outlined"
            onClick={onClose}
            color="error"
            sx={{ borderColor: "#f44336", color: "#b71c1c" }}
          >
            {cancelText}
          </Button>
          <Button variant="contained" color="error" onClick={onConfirm}>
            {confirmText}
          </Button>
        </Box>
      </DialogContent>
    </AlertBootstrapDialog>
  );
};

export default memo(AlertConfirmationModal);
